import React from 'react';
import http from '@/services/http';
import { SHOP_URL } from './urls';

class ShopController extends React.Component {
	getAll = async cityId => {
		// console.log("getAllShops", cityId);
		let data;

		try {
			const res = await http.get(`${SHOP_URL}${cityId || ''}`);
			// console.log(res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			shops: data.shops,
		};
	};

	add = async (shop, cityId) => {
		// console.log("addShop");
		let data;

		try {
			const res = await http.post(`${SHOP_URL}${cityId || ''}`, { shop });
			console.log('res from add', res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	edit = async (shopId, shop) => {
		// console.log("editShop", shopId);
		let data;

		try {
			const res = await http.put(`${SHOP_URL}${shopId}`, { shop });
			console.log('res from put', res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	delete = async shopId => {
		console.log('deleteShop');
		let data;

		try {
			// console.log(shop)
			const res = await http.delete(`${SHOP_URL}${shopId}`);
			console.log('res from deleteShop', res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};
}

const shopController = new ShopController();

export default shopController;
